// 计提数据模块常量定义

export const PROVISION_DATA_MODULE = 100
export const PROVISION_GENERATE_BASIC = 1
export const PROVISION_DATA_QUERY = 2
export const PROVISION_JOB_DETAIL = 3

export const STATION_ENUMS = {
  OPERATION: '操作',
  BUSINESS: '商务',
  CUSTOMS: '报关',
  CUSTOMER_SERVICE: '客服'
}

export const CONFIGURABLE_STATIONS = [
  { label: '市场拓展专员', value: '市场拓展专员' },
  { label: '市场拓展负责人', value: '市场拓展负责人' },
  { label: '客服', value: '客服' },
  { label: '客服主管', value: '客服主管' },
  { label: '操作', value: '操作' },
  { label: '操作主管', value: '操作主管' },
  { label: '海外跟单', value: '海外跟单' },
  { label: '跟单主管', value: '跟单主管' }
]

export const ALL_GENERATE_STATIONS = [...CONFIGURABLE_STATIONS]

export const CALC_TYPE_OPTIONS = [
  { label: '毛利百分比', value: 'percent' },
  { label: '业务分类计提', value: 'fixed' },
  { label: '阶梯提成', value: 'tier' },
  { label: '团队提成', value: 'team' },
  { label: '固定奖励', value: 'fixed_bonus' }
]

export const PROGRESSIVE_MODE_OPTIONS = [
  { label: '全额累进', value: 'full' },
  { label: '超额累进', value: 'excess' }
]

export const TIER_MODE_OPTIONS = [
  { label: '毛利提成', value: 'profit' },
  { label: '票数提成', value: 'ticket' }
]

/**
 * 自定义业务类型 (OMS_JOB.CUSTOM_JOB_TYPE) 全量候选值。
 * 来源：原版操作提成按 customJobType 分类时实际使用到的取值。
 */
export const CUSTOM_JOB_TYPE_OPTIONS = ['A', 'B', 'C', 'D', 'F', 'H', 'I', 'J', 'K']

/**
 * 业务类型 (OMS_JOB.LOB) 全量候选值。
 * SE=海运出口 SI=海运进口 AE=空运出口 AI=空运进口 RE=铁路出口 RI=铁路进口
 */
export const LOB_OPTIONS = [
  { value: 'SE', label: '海运出口' },
  { value: 'SI', label: '海运进口' },
  { value: 'AE', label: '空运出口' },
  { value: 'AI', label: '空运进口' },
  { value: 'RE', label: '铁路出口' },
  { value: 'RI', label: '铁路进口' }
]

export const CONDITION_FIELD_OPTIONS = [
  { label: '计息毛利', value: 'profit' },
  { label: '业务类型', value: 'lob' },
  { label: '自定义业务类型', value: 'customJobType' },
  { label: '客户类型', value: 'customerType' },
  { label: '个人订单总计息毛利', value: 'personalProfitTotal' },
  { label: '个人总票数', value: 'personalTicketTotal' }
]

/**
 * 客户类型 (CustomerTypeEnum) 候选项(多选)。
 * value 与后端 ProvisionJobVO.customerType / resolveCustomerType 返回的 code 一致(direct/peer)。
 * 判定口径(后端)：SYS_PARTNER.PEER=1 → peer(同行)，否则 direct(直客)；PEER 列未上线前统一为 direct。
 */
export const CUSTOMER_TYPE_OPTIONS = [
  { value: 'direct', label: '直客' },
  { value: 'peer', label: '同行客户' }
]

export const BIZ_CATEGORY_LINE_MODE_OPTIONS = [
  { label: '固定金额(票数×金额)', value: 'ticket' },
  { label: '提成比例(计息毛利×比例)', value: 'profit' }
]

export const BIZ_CATEGORY_COMBINE_MODE_OPTIONS = [
  { label: '单独计算', value: 'separate' },
  { label: '累加计算', value: 'additive' }
]

export const OVERLAP_MODE_OPTIONS = [
  { label: '个人规则+岗位规则叠加', value: 'overlap' },
  { label: '仅使用个人规则(覆盖岗位)', value: 'override' }
]

export const SALES_STATION_OPTIONS = [
  { label: '市场拓展专员', value: '市场拓展专员' },
  { label: '市场拓展负责人', value: '市场拓展负责人' }
]

/** @deprecated 请优先使用 SALES_STATION_OPTIONS；保留字符串数组供 isSalesStation 等判断 */
export const SALES_STATIONS = SALES_STATION_OPTIONS.map(item => item.value)

export const PERSON_COST_TYPE_OPTIONS = [
  { label: '底薪', value: 'base_salary' },
  { label: '坏账', value: 'bad_debt' },
  { label: '罚款', value: 'fine' },
  { label: '赔偿', value: 'compensation' }
]

export const ZERO_COST_FLAG_OPTIONS = [
  { label: '是', value: '1' },
  { label: '否', value: '0' }
]

export function getPersonCostTypeLabel(code) {
  const all = [...PERSON_COST_TYPE_OPTIONS, { label: '毛利抵扣', value: 'profit_deduct' }]
  const hit = all.find(item => item.value === code)
  return hit ? hit.label : code
}

export function isSalesStation(stationName) {
  return SALES_STATIONS.includes(stationName)
}

/** 新规则体系下可配置岗位（人员成本、计息毛利提成等） */
export function isConfigurableStation(stationName) {
  return CONFIGURABLE_STATIONS.some(item => item.value === stationName)
}

export function getCalcTypeLabel(value) {
  const item = CALC_TYPE_OPTIONS.find(o => o.value === value)
  return item ? item.label : value
}

export function formatRuleValue(row) {
  if (!row) return '-'
  if (row.calcType === 'percent') return row.percentRate + '%'
  if (row.calcType === 'fixed') return '查看业务分类'
  if (row.calcType === 'fixed_bonus') return '查看档位'
  if (row.calcType === 'team') return 'X=' + row.teamDeductBase + ', Y=' + row.teamPercentRate + '%'
  if (row.calcType === 'tier') return '查看阶梯'
  return '-'
}

export const STANDARD_STATE = { UNCALIBRATED: '0', CALIBRATED: '1' }
export const PUBLISH_STATE = { UNPUBLISHED: '0', PUBLISHED: '1' }
export const CONFIRM_STATE = { UNCONFIRMED: '0', CONFIRMED: '1' }

export function getStationLabel(value) {
  const map = { '操作': '操作', '商务': '商务', '报关': '报关', '客服': '客服' }
  return map[value] || value
}

export function getStandardStateLabel(value) {
  return value === '1' ? '已校准' : '未校准'
}

export function getPublishStateLabel(value) {
  return value === '1' ? '已发布' : '未发布'
}
